export const getSpreadSheet = async ({ id, range }: any) => {
  // @ts-ignore
  const response = await gapi.client.sheets.spreadsheets.values.get({
    spreadsheetId: id,
    range,
    majorDimension: "COLUMNS",
  });
  return response.result;
};
